// extracted by mini-css-extract-plugin
export default {"rightPart":"LandingPage_rightPart__gqpan","title":"LandingPage_title__kJc07","btn":"LandingPage_btn__t4ZXf","stepLabels":"LandingPage_stepLabels__102l+"};